export const iconFontAwesomeScienceVialCircleCheck = (
	<i className="fa-solid fa-vial-circle-check"></i>
);
